import request from '@/utils/axios';
import qs from 'qs';

// x-www-form-urlencoded
export const token = p => request.post('/auth/oauth/token', qs.stringify(Object.assign({grant_type: 'password'}, p)), {headers: {Authorization:'Basic d2ViOjk3ZTAxNzA5LTU3NTUtNGVlOS05OTVmLWY5M2M1MDdhZjQ2Yw=='}});
